import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import BackgroundPattern from '../components/BackgroundPattern';
import Footer from '../components/Footer';
import blogPosts from '../data/blogPosts';

const BlogDetail = () => {
  const { slug } = useParams();
  const post = blogPosts.find((item) => item.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  if (!post) {
    return (
      <div className="min-h-screen text-white relative" style={{ backgroundColor: '#0a0a1a' }}>
        <BackgroundPattern />
        <Navbar />
        <main className="relative z-10 pt-28 pb-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <div className="rounded-3xl border border-red-500/40 bg-red-500/10 px-6 py-4 text-red-200">
              <h1 className="text-2xl font-semibold">Post not found</h1>
              <p className="mt-3 text-gray-300">
                We could not locate the blog post you were trying to read. It may have been moved or renamed.
              </p>
            </div>
            <Link
              to="/blog"
              className="mt-8 inline-flex items-center gap-2 rounded-full border border-indigo-500/40 bg-indigo-500/10 px-6 py-3 text-sm font-medium text-indigo-200 transition-colors duration-200 hover:border-indigo-400 hover:bg-indigo-500/20"
            >
              Return to Blog
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen text-white relative" style={{ backgroundColor: '#0a0a1a' }}>
      <BackgroundPattern />
      <Navbar />

      <article className="relative z-10 pt-24 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <header className="mb-12">
            <div className="relative overflow-hidden rounded-3xl border border-indigo-500/30 bg-gray-900/50">
              <div className={`absolute inset-0 bg-gradient-to-br ${post.imageGradient}`} />
              <div className="relative px-6 py-12 sm:px-10 sm:py-16">
                <span className="inline-flex items-center rounded-full border border-indigo-500/40 bg-indigo-500/10 px-4 py-1 text-xs sm:text-sm font-medium uppercase tracking-wider text-indigo-200">
                  Featured Insight
                </span>
                <h1 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-bold text-white">
                  {post.title}
                </h1>
                <div className="mt-6 flex flex-wrap items-center gap-3 text-sm text-indigo-100/80">
                  <span className="font-medium text-indigo-100">{post.author}</span>
                  <span className="text-indigo-200/60">•</span>
                  <span>{post.date}</span>
                  <span className="text-indigo-200/60">•</span>
                  <span>{post.readTime}</span>
                </div>
              </div>
            </div>
          </header>

          <section className="space-y-6 text-base sm:text-lg leading-relaxed text-gray-200">
            {post.content.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </section>

          <footer className="mt-16 flex flex-wrap items-center justify-between gap-4">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 rounded-full border border-indigo-500/40 bg-indigo-500/10 px-6 py-3 text-sm font-medium text-indigo-200 transition-colors duration-200 hover:border-indigo-400 hover:bg-indigo-500/20"
            >
              ← Back to Blog
            </Link>
            <div className="text-sm text-gray-400">
              <span>Share this post</span>
              <span className="ml-2 text-indigo-300">•</span>
              <span className="ml-2 text-indigo-200">#VAISPtech</span>
            </div>
          </footer>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default BlogDetail;
